import Vue from 'vue'
import Resource from 'vue-resource'
import VeeValidate from 'vee-validate'
// import VueSocketio from 'vue-socket.io'
import NProgress from 'vue-nprogress'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'
import auth from './auth/index'
import OccurrenceTableButtons from './components/occurrences/OccurrenceTableButtons.vue'
import OccurrenceGenericTableButtons from './components/occurrences/OccurrenceGenericTableButtons.vue'
import ServiceTableButtons from './components/services/ServiceTableButtons.vue'
import UserTableButtons from './components/users/UserTableButtons.vue'
import AgencyTableButtons from './components/agencies/AgencyTableButtons.vue'
import ClientTableButtons from './components/users/ClientTableButtons.vue'
import TrendingTableButtons from './components/trending/TrendingTableButtons.vue'
import SalesTableButtons from './components/finances/SalesTableButtons.vue'
import ServicesInvoiceTableButtons from './components/finances/ServicesInvoiceTableButtons.vue'
import ServicesPaymentTableButtons from './components/finances/ServicesPaymentTableButtons.vue'
import InvoicesTableButtons from './components/finances/InvoicesTableButtons.vue'
import InvoicesTableButtonsV2 from './components/finances/V2/invoice/InvoicesTableButtons.vue'
import InvoicesClientTableButtons from './components/finances/InvoicesClientTableButtons.vue'
import PaymentsTableButtons from './components/finances/PaymentsTableButtons.vue'
import PaymentsTableButtonsV2 from './components/finances/V2/payment/PaymentsTableButtons.vue'
import ExchangeTableButtons from './components/finances/ExchangeTableButtons.vue'
import BaseTableButtons from './components/bases/BaseTableButtons.vue'
import SaveTableButtons from './components/bi/SaveTableButtons.vue'
import ChangeTableButtons from './components/bi/ChangeTableButtons.vue'
import ProviderTableButtons from './components/customer/ProviderTableButtons.vue'
import ChainTableButtons from './components/customer/ChainTableButtons.vue'
import ChainsHotelTableButtons from './components/customer/ChainsHotelTableButtons.vue'
import AccountsTableButtons from './components/finances/AccountsTableButtons.vue'
import RefundsTableButtons from './components/finances/RefundsTableButtons.vue'
import RefundsTableButtonsV2 from './components/finances/V2/RefundsTableButtons.vue'
import RefundsPaymentTableButtons from './components/finances/V2/RefundsPaymentTableButtons.vue'
import NfseTableButtons from './components/finances/NfseTableButtons.vue'
import DebitsCreditsTableButtons from './components/finances/DebitsCreditsTableButtons.vue'
import VueDragscroll from 'vue-dragscroll'
import Update from './components/notifications/update'
import InvoicePaymentRuleTableButtons from './components/finances/InvoicePaymentRuleTableButtons.vue'
import BookingsMissingTableButtons from './components/services/BookingsMissingTableButtons.vue'
import CardServicesTableButtons from './components/finances/CardServicesTableButtons.vue'
import HotelTableButtons from './components/hotels/HotelTableButtons.vue'
import CardsTableButtons from './components/finances/CardsTableButtons.vue'
import PlatformTableButtons from './components/customer/PlatformTableButtons.vue'
import LogsTableButtons from './components/logs/LogTableButtons.vue'
import VueCardFormat from 'vue-credit-card-validation'
import Loading from 'vue-loading-overlay'
import axios from 'axios'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'

const configValidate = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fieldsValidate',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'en',
  strict: true,
  validity: false
}
Vue.use(Resource)
Vue.use(VeeValidate, configValidate)
Vue.use(NProgress)
Vue.use(Loading)
Vue.use(require('vue-moment'))
Vue.use(VueCardFormat)
// Vue.use(VueSocketio, 'http://localhost:3000')
Vue.use(VueDragscroll)
Vue.component('occurrence-table-buttons', OccurrenceTableButtons)
Vue.component('occurrence-generic-table-buttons', OccurrenceGenericTableButtons)
Vue.component('service-table-buttons', ServiceTableButtons)
Vue.component('user-table-buttons', UserTableButtons)
Vue.component('agency-table-buttons', AgencyTableButtons)
Vue.component('client-table-buttons', ClientTableButtons)
Vue.component('trending-table-buttons', TrendingTableButtons)
Vue.component('sales-table-buttons', SalesTableButtons)
Vue.component('services-invoice-table-buttons', ServicesInvoiceTableButtons)
Vue.component('services-payment-table-buttons', ServicesPaymentTableButtons)
Vue.component('invoices-table-buttons', InvoicesTableButtons)
Vue.component('invoices-table-buttons-v2', InvoicesTableButtonsV2)
Vue.component('payments-table-buttons', PaymentsTableButtons)
Vue.component('payments-table-buttons-v2', PaymentsTableButtonsV2)
Vue.component('exchange-table-buttons', ExchangeTableButtons)
Vue.component('base-table-buttons', BaseTableButtons)
Vue.component('save-table-buttons', SaveTableButtons)
Vue.component('change-table-buttons', ChangeTableButtons)
Vue.component('provider-table-buttons', ProviderTableButtons)
Vue.component('chain-table-buttons', ChainTableButtons)
Vue.component('accounts-table-buttons', AccountsTableButtons)
Vue.component('refunds-table-buttons', RefundsTableButtons)
Vue.component('refunds-table-buttons-v2', RefundsTableButtonsV2)
Vue.component('refunds-payment-table-buttons', RefundsPaymentTableButtons)
Vue.component('nfse-table-buttons', NfseTableButtons)
Vue.component('debits-credits-table-buttons', DebitsCreditsTableButtons)
Vue.component('invoice-payment-rule-table-buttons', InvoicePaymentRuleTableButtons)
Vue.component('bookings-missing-table-buttons', BookingsMissingTableButtons)
Vue.component('card-services-table-buttons', CardServicesTableButtons)
Vue.component('invoices-client-table-buttons', InvoicesClientTableButtons)
Vue.component('hotel-table-buttons', HotelTableButtons)
Vue.component('cards-table-buttons', CardsTableButtons)
Vue.component('platform-table-buttons', PlatformTableButtons)
Vue.component('log-table-buttons', LogsTableButtons)
Vue.component('chains-hotel-table-buttons', ChainsHotelTableButtons)

sync(store, router)

const nprogress = new NProgress({ parent: '.nprogress-container' })

const { state } = store
const { config } = state

router.beforeEach((route, redirect, next) => {
  if (config.mobile && config.sidebar) {
    config.sidebar = false
  }
  if (config.token) {
    try {
      axios.get(config.apiURL + '/route/check?route=' + route.matched[0].path.replace(':id', ''), {headers: {Authorization: `Bearer ${config.token.access_token}`}}).then((response) => {
      }, (response) => {
        if (response.response.status === 401) {
          window.localStorage.clear()
          window.sessionStorage.clear()
          window.location.href = './'
        }
      })
    } catch (e) {
      console.log(e)
    }
  }
  if (route.matched.some(record => record.meta.requiresAuth)) {
    if (!config.logged) {
      next({
        path: 'login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const app = new Vue({
  router,
  store,
  nprogress,
  ...App
})

export { app, router, store }

Vue.http.interceptors.push(function (request, next) {
  if (auth.logged(this)) {
    request.headers.append('Authorization', 'Bearer ' + this.$store.state.config.token.access_token)
    request.headers.append('Version', this.$store.state.config.version)
  }
  let loader = this.$loading.show({
    // Optional parameters
    container: null,
    canCancel: false,
    color: '#A71C20',
    'background-color': '#000000',
    opacity: 0.4
  })
  next(function (response) {
    loader.hide()
    if (response.url !== this.$store.state.config.apiURL + '/login') {
      if (response.status === 401) {
        auth.logout(this, true)
      } else if (response.status === 205) {
        let propsData = {
          context: this
        }
        Update.openUpdate(propsData)
      } else if (response.status === 400) {
        window.location.href = './'
      }
    }
  })
})



// WEBPACK FOOTER //
// ./client/app.js